import React from "react";
import { Button, Menu } from "antd";
import { Header } from "antd/lib/layout/layout";
import { Link } from "react-router-dom";
import { SendOutlined } from "@ant-design/icons";

const Navbar = () => {
  return (
    <Header>
      <Link className="logo" to="/" style={{ fontSize: "2rem" }}>
        <span style={{ color: "#ff4d4f" }}> Abdur </span> Rahman
      </Link>
      <Menu theme="dark" mode="horizontal" style={{ float: "right" }}>
        <Button type="primary" ghost>
          <Link to="/"> Home </Link>
        </Button>
        <Button type="primary" ghost style={{ margin: "0 1rem " }}>
          <Link to="/Portfolio"> Portfolio </Link>
        </Button>
        <Button type="primary" ghost>
          <Link to="/About"> About </Link>
        </Button>
        <Button type="primary" ghost style={{ margin: "0 1rem " }}>
          <Link to="/Blog"> Blog </Link>
        </Button>
        <Button type="primary" ghost>
          <Link to="/Contact"> Contact </Link>
        </Button>
        <a
          href="https://drive.google.com/file/d/1OM7DonCvZ7TEdMOgVD6xheHVyLhK1CIT/view?usp=sharing"
          target="_blank"
          rel="noreferrer"
        >
          <Button type="primary" ghost style={{ marginLeft: "1rem " }}>
            <SendOutlined />
          </Button>
        </a>
      </Menu>
    </Header>
  );
};

export default Navbar;
